import { useEffect, useRef, useState } from "react";
import StreamingAvatar, {
  AvatarQuality,
  StreamingEvents,
  TaskType,
} from "@heygen/streaming-avatar";
import axios from "axios";

const HeygenAvatar = ({ roomName , setText, text , setIsAvatarConnected }) => {
  const [avatar, setAvatar] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  // const [text, setText] = useState("");
  const videoRef = useRef(null);

  useEffect(() => {
    setIsAvatarConnected(connected);
  }, [connected]);

  const startSession = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/assistant/create-heygen-token/?room_name=${roomName}`
      );

      const { session_id } = res.data;
      if (!session_id) throw new Error("No session_id returned from backend");

      // ✅ Correct default import usage
      const streamingAvatar = new StreamingAvatar({
        token: process.env.REACT_APP_HEYGEN_API_KEY,
      });

      streamingAvatar.on(StreamingEvents.STREAM_READY, (event) => {
        const mediaStream = event.detail?.stream || event.detail;
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
          videoRef.current.onloadedmetadata = () => videoRef.current.play();
        }
        setConnected(true);
      });

      streamingAvatar.on(StreamingEvents.AVATAR_TALKING_MESSAGE, (msg) => {
        
      });

      streamingAvatar.on(StreamingEvents.AVATAR_END_MESSAGE, (msg) => {
        // console.log("✅ Avatar finished:", msg);
      });

      streamingAvatar.on(StreamingEvents.STREAM_DISCONNECTED, () => {
        if (videoRef.current) videoRef.current.srcObject = null;
        setConnected(false);
      });

      const sessionData = await streamingAvatar.createStartAvatar({
        avatarName: "Anastasia_Grey_Shirt_public",
        quality: AvatarQuality.High,
        voice: {
          voice_id: "2d5b0e6cf36f460aa7fc47e3eee4ba54",
          speed: 1.0,
          emotion: "Friendly",
        },
        initial_text: "Hello there! I’m your virtual assistant.",
      });

      setAvatar(streamingAvatar);
      setSessionId(sessionData.session_id);
    } catch (error) {
      console.error("❌ Error starting avatar session:", error);
      alert("Failed to start HeyGen avatar session");
    } finally {
      setLoading(false);
    }
  };

  const stopSession = async () => {
    if (!avatar || !sessionId) return;
    try {
      await avatar.stopSession({ sessionId });
      setAvatar(null);
      setSessionId(null);
      setConnected(false);
      if (videoRef.current) videoRef.current.srcObject = null;
    } catch (err) {
      console.error("Error stopping session:", err);
    }
  };

  const handleSpeak = async (text) => {
    if (!avatar || !sessionId) return;
    // console.log("Speaking:", text);
    try {
      await avatar.speak({
        sessionId,
        text,
        task_type: TaskType.REPEAT,
      });
      setText("");
    } catch (err) {
      // console.error("❌ Speak error:", err);
    }
  };

  useEffect(() => {
      handleSpeak(text);
  }, [text]);

  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <h2>HeyGen Live Avatar</h2>

      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{
          width: "480px",
          background: "#000",
          borderRadius: "8px",
          marginBottom: "1rem",
        }}
      />

      {!connected ? (
        <button onClick={startSession} disabled={loading}>
          {loading ? "Starting Avatar..." : "Start Avatar"}
        </button>
      ) : (
        <button onClick={stopSession}>Stop Avatar</button>
      )}
    </div>
  );
};

export default HeygenAvatar;
